import { useHits } from 'react-instantsearch'

import { ProductItem } from 'components/molecules/hit-product-card/type'
import { useGetFavouriteProducts } from 'features/retailer/favourites/hooks/use-get-all-favourite-products'

import { useTranslate } from 'hooks'
import useBatchProductPrices from 'hooks/common/use-batch-products-prices'
import { useIsLoggedIn } from 'hooks/use-is-logged-in'

const useHitProducts = () => {
  const { lang } = useTranslate('common')
  const { hits, results } = useHits<ProductItem>()
  const { isLoggedIn } = useIsLoggedIn()
  const { data: favouriteProducts } = useGetFavouriteProducts(lang, isLoggedIn)
  const skuNames = hits.map((hit) => hit.sku)
  const { data: skusPricesByProductId, isLoading: isLoadingPrices } = useBatchProductPrices(skuNames, lang, isLoggedIn)

  const isLoading = (results?.__isArtificial && hits.length === 0) || isLoadingPrices
  const hasResult = !results?.__isArtificial && hits.length > 0

  return {
    hits,
    isLoading,
    hasResult,
    isLoggedIn,
    favouriteProducts,
    skusPricesByProductId,
  }
}

export default useHitProducts
